import { render, staticRenderFns } from "./Appt.vue?vue&type=template&id=1a8f0822&"
import script from "./Appt.vue?vue&type=script&lang=ts&"
export * from "./Appt.vue?vue&type=script&lang=ts&"
import style0 from "./Appt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports